/*
 * @Author: Latte
 * @Date: 2021-08-03 13:59:40
 * @LAstEditors: Latte
 * @LastEditTime: 2021-08-23 17:31:02
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\diagnosisManagement\diagnosticTeamUser.js
 */

import request from '@/utils/request'
import config from '@/utils/config'

/**
 * @description: 设置团队管理员
 * @param {*} data
 * @return {*}
 */
export function setManager(data) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/admin',
    method: 'patch',
    data
  })
}

/**
 * @description: 删除团队成员
 * @param {*} params
 * @return {*}
 */
export function deleteMember(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/delete',
    method: 'delete',
    params
  })
}

/**
 * @description: 获取指定成员信息
 * @param {*} params
 * @return {*}
 */
export function getMemberDetail(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/list',
    method: 'get',
    params
  })
}

/**
 * @description: 给予团队成员阅片权限
 * @param {*} data
 * @return {*}
 */
export function allowMemberPermission(data) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/permission',
    method: 'post',
    params: data,
  })
}

/**
 * @description: 取消团队成员阅片权限
 * @param {*} data
 * @return {*}
 */
export function cancelMemberPermission(data) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/permission',
    method: 'post',
    params: data,
  })
}